import { render, staticRenderFns } from "./CardListProductPagesGrid.vue?vue&type=template&id=452411ac&scoped=true"
import script from "./CardListProductPagesGrid.vue?vue&type=script&lang=js"
export * from "./CardListProductPagesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452411ac",
  null
  
)

export default component.exports